import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class ZoneRackIdRequest {
    @ApiProperty()
    zoneId: number;
    @ApiProperty()
    rackId: number;
    @ApiProperty()
    plantId?: number;
    @ApiProperty()
    poNo?: number;
    @ApiProperty()
    varient?: number;
    @ApiProperty()
    saleOrderId?: number;
}